<template>
  <van-popup
    :show="show"
    :position="useIsMobile().value ? 'bottom' : 'center'"
    closeable
    :before-close="handleClose"
  >
    <div>
      <slot />
    </div>
    <div class="share-list">
      <div
        v-for="item in shareItems"
        :key="item.key"
        class="share-item"
        @click="handleShareClick(item)"
      >
        <img
          :src="$cvWebpFn(item.icon)"
          alt=""
        >
        <p class="title">
          {{ item.name }}
        </p>
      </div>
    </div>
  </van-popup>
</template>
<script lang="ts" setup>
interface IShareItem { icon: string, name: string, key: string }
withDefaults(
  defineProps<{
    shareItems?: IShareItem[],
    show: boolean
  }>(),
  {
    shareItems: () => ([
      { icon: 'https://image.kilimall.com/lite/seller-wap/ic_facebook_new.png', name: 'Facebook', key: 'Facebook' },
      { icon: 'https://image.kilimall.com/lite/seller-wap/ic_whatsapp_new.png', name: 'WhatsApp', key: 'WhatsApp' },
      { icon: 'https://image.kilimall.com/lite/seller-wap/ic_sms_new.png', name: 'SMS', key: 'SMS' },
      { icon: 'https://image.kilimall.com/lite/seller-wap/ic_copy_link_new.png', name: 'Copy Link', key: 'CopyLink' }
    ])
  }
)
const emits = defineEmits<{
  (event: 'update:show', show: boolean): void,
  (event: 'share:click', item: IShareItem): void
}>()

const handleShareClick = (share: IShareItem) => {
  emits('share:click', share)
}
const handleClose = () => {
  emits('update:show', false)
}
</script>

<style lang="scss" scoped>
.share-list{
  display: flex;
  flex-wrap: wrap;
  // justify-content: space-between;
  padding: 150px 30px 40px 30px;
  .share-item{
    width: 25%;
    text-align: center;
    color: #666666;
    font-size: 24px;
    line-height: 28px;
    margin-bottom: 40px;
    img{
      width: 92px;
      height: 92px;
      margin-bottom: 18px;
    }
  }
}
</style>
